import { Component, OnInit } from '@angular/core';
import { EnvService } from '@forgerock/backstage-ui-core';
import { DashboardEnv } from '../model/dashboard-env';

@Component({
    selector: 'app-dashboard-links-panel',
    templateUrl: './dashboard-links-panel.component.html',
    styleUrls: ['./dashboard-links-panel.component.scss'],
    standalone: false
})
export class DashboardLinksPanelComponent implements OnInit {
  trainingUrl: string | null = null;
  downloadsUrl: string | null = null;

  constructor(private readonly envService: EnvService<DashboardEnv>) {}

  async ngOnInit(): Promise<void> {
    try {
      const env = await this.envService.get();
      this.trainingUrl = env.trainingBaseUrl;
      this.downloadsUrl = env.downloadsBaseUrl;
    } catch {
      this.trainingUrl = null;
      this.downloadsUrl = null;
    }
  }
}
